<template>
  <div class="flex flex-col gap-4">
    <div v-if="items.length === 0" class="text-center py-8 text-text-secondary">
      <p>Your cart is empty</p>
    </div>
    <div v-else class="flex flex-col gap-3">
      <div
        v-for="(item, index) in items"
        :key="`${item.item_id}-${item.attribute_id}-${index}`"
        class="flex items-start gap-3 p-3 bg-gray-50 rounded-xl border border-border"
      >
        <div class="flex-1 min-w-0">
          <h4 class="font-medium text-text-primary m-0">{{ item.item_name }}</h4>
          <p class="text-sm text-text-secondary m-0 mt-0.5">
            {{ formatRs(item.total_amount ?? item.item_amount ?? 0) }}
            <span v-if="item.attribute_name" class="text-text-secondary">
              · {{ item.attribute_name }}
            </span>
          </p>
          <p class="text-sm text-text-muted m-0 mt-0.5">Quantity: {{ item.count }}</p>
          <p v-if="item.order_comment" class="text-xs text-text-muted mt-1 m-0">
            {{ item.order_comment }}
          </p>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            class="flex items-center justify-center w-9 h-9 rounded-full border border-border bg-white text-text-primary hover:bg-gray-50 transition-colors"
            aria-label="Edit item"
            @click="$emit('edit', item)"
          >
            <Icon name="pencil-simple" :size="18" weight="regular" />
          </button>
          <button
            type="button"
            class="flex items-center justify-center w-9 h-9 rounded-full border border-border bg-white text-text-primary hover:bg-red-50 hover:border-red-200 transition-colors"
            aria-label="Remove from cart"
            @click="$emit('remove', item.item_id, item.attribute_id)"
          >
            <Icon name="x" :size="18" weight="bold" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/atoms/Icon.vue'
import { useCurrency } from '@/composables/core/useCurrency'
import type { OrderItem } from '@/interfaces'

interface Props {
  items: OrderItem[]
}

defineProps<Props>()

defineEmits<{
  remove: [itemId: string, attributeId: string]
  edit: [item: OrderItem]
}>()

const { formatDefaultPrice: formatRs } = useCurrency()
</script>
